class MockLocalStorage {
    constructor() {
        this.store = {};
    }
    setItem(key, val) {
        this.store[key] = val;
    }
    getItem(key) {
        return this.store[key];
    }
    removeItem(key) {
        delete this.store[key];
    }
}

const mockLocalStorage = new MockLocalStorage();

function getLocalStorage() {
    let localStorage;
    try {
        localStorage = window.localStorage || mockLocalStorage;
    } catch (err) {
        localStorage = mockLocalStorage;
        // eslint-disable-next-line no-console
        console.error(err, "getLocalStorage() failed");
    }
    return localStorage;
}

export default getLocalStorage;
